import { getRequest, postRequest } from '../../../api/api';

export function getProfileData(callbackResponse) {
    return getRequest(
        'api/v1/wallet/profile',
        null,
        callbackResponse
    );
};

export function getSummaryInvestmentData(callbackResponse) {
    return getRequest(
        'api/v1/wallet/net-fund',
        null,
        callbackResponse
    );
};

export function postChangePassword(values, callbackResponse) {
    return postRequest(
        '/api/v1/change-password',
        null,
        values,
        callbackResponse
    );
};

export function getPAFile() {
    
};